/* Aycan cart drawer — discount code apply/remove.
   Uses /cart/update.js {discount:"CODE"} (apply / validate) and {discount:""}
   (remove), then re-renders the drawer via the Section Rendering API so totals
   + applied-chip reflect server truth. Gift cards are checkout-only (Shopify). */
class AycanCartPromo extends HTMLElement {
  connectedCallback() {
    if (this._ran) return;
    this._ran = true;
    this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    this.addEventListener('click', (e) => {
      const apply = e.target.closest('[data-promo-apply]');
      const remove = e.target.closest('[data-promo-remove]');
      if (apply) { e.preventDefault(); this.apply(); }
      else if (remove) { e.preventDefault(); this.remove(); }
    });
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && e.target.matches('[data-promo-input]')) { e.preventDefault(); this.apply(); }
    });
  }

  get input() { return this.querySelector('[data-promo-input]'); }
  get msg() { return this.querySelector('[data-promo-msg]'); }

  setMsg(text, isError) {
    if (!this.msg) return;
    this.msg.textContent = text || '';
    this.msg.hidden = !text;
    this.msg.classList.toggle('is-error', !!isError);
  }

  busy(on) { this.classList.toggle('is-busy', !!on); }

  update(discount) {
    return fetch(`${this.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount }),
    }).then((r) => r.json());
  }

  apply() {
    const code = (this.input && this.input.value || '').trim();
    if (!code) { this.setMsg('Enter a code', true); return; }
    this.busy(true);
    this.setMsg('');
    this.update(code).then((cart) => {
      const entry = (cart.discount_codes || []).find(
        (d) => d.code && d.code.toLowerCase() === code.toLowerCase()
      );
      if (entry && entry.applicable) {
        this.rerender();
      } else {
        // clear the rejected code so it never leaks to checkout, then report
        this.update('').finally(() => {
          this.busy(false);
          this.setMsg(`“${code}” isn’t a valid code`, true);
        });
      }
    }).catch(() => { this.busy(false); this.setMsg('Something went wrong — try again', true); });
  }

  remove() {
    this.busy(true);
    this.update('').then(() => this.rerender()).catch(() => this.busy(false));
  }

  rerender() {
    return fetch(`${this.root}?sections=cart-drawer`)
      .then((r) => r.json())
      .then((data) => {
        const html = data && data['cart-drawer'];
        if (!html) { window.location.reload(); return; }
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
        const current = document.querySelector('#CartDrawer .drawer__inner') || document.querySelector('.drawer__inner');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .catch(() => window.location.reload());
  }
}
if (!customElements.get('aycan-cart-promo')) {
  customElements.define('aycan-cart-promo', AycanCartPromo);
}
